import { render } from "./EventFieldsForm.vue?vue&type=template&id=592018de&scoped=true"
import script from "./EventFieldsForm.vue?vue&type=script&lang=ts"
export * from "./EventFieldsForm.vue?vue&type=script&lang=ts"

import "./EventFieldsForm.vue?vue&type=style&index=0&id=592018de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-592018de"

export default script